import {
  ADICIONAR_PASSAGEIROS_VOLTA, ALTERAR_COMPRADOR_VOLTA,
  ALTERAR_PASSAGEIRO_VOLTA,
  ALTERAR_TIPO_EMISSAO_PASSAGEIRO_VOLTA
} from '../../actions/types';

const initialState = []

export default function reducerPassageirosVolta (state = initialState, action) {
  switch (action.type) {
    case ADICIONAR_PASSAGEIROS_VOLTA: {
      return action.payload
    }
    case ALTERAR_PASSAGEIRO_VOLTA: {
      const passageiro = action.payload;
      const indice = state.indexOf(state.filter(f => f.poltronaId === passageiro.poltronaId)[0]);
      const novaPassageiro = Object.assign({}, passageiro);
      const passageiros = Object.assign([], state);
      passageiros[indice] = novaPassageiro;

      return passageiros
    }
    case ALTERAR_COMPRADOR_VOLTA: {
      const passageiro = action.payload;
      const indice = state.indexOf(state.filter(f => f.poltronaId === passageiro.poltronaId)[0]);
      const novaPassageiro = Object.assign({}, passageiro);
      novaPassageiro.ehComprador = !novaPassageiro.ehComprador;
      const passageiros = state
          .map(passageiro => Object.assign({}, passageiro,
              { ehComprador: false }));
      passageiros[indice] = novaPassageiro;

      return passageiros
    }
    case ALTERAR_TIPO_EMISSAO_PASSAGEIRO_VOLTA: {
      const passageiros = state
      const novaListagem = passageiros
        .map(passageiro => Object.assign({}, passageiro,
          { tipoEmissao: passageiro.tipoEmissao.value ? passageiro.tipoEmissao.value : passageiro.tipoEmissao }))
      return novaListagem
    }
    default:
      return state
  }
}
